/**
 * Single source of truth for upload size limits on the FRONTEND.
 * Must stay aligned with backend `KIND_CONFIG` in `storage_service.py`.
 *
 * The production Kubernetes ingress also enforces a body size cap which
 * is typically ~100MB. To stay safely below it we keep post_video at
 * 50MB. Larger files would be rejected by the proxy with HTTP 413
 * before they ever reach the backend, producing a confusing failure.
 */

export const UPLOAD_LIMITS = {
  avatar: { maxBytes: 5 * 1024 * 1024, label: "5 MB" },
  banner: { maxBytes: 10 * 1024 * 1024, label: "10 MB" },
  post_photo: { maxBytes: 10 * 1024 * 1024, label: "10 MB" },
  post_video: { maxBytes: 50 * 1024 * 1024, label: "50 MB" },
  voice_note: { maxBytes: 25 * 1024 * 1024, label: "25 MB" },
};

/**
 * Returns null if the file fits, or a user-facing error message otherwise.
 * @param {string} kind - upload kind matching backend KIND_CONFIG
 * @param {File} file - the File / Blob being uploaded
 */
export function validateUpload(kind, file) {
  if (!file) return "No file selected.";
  const cfg = UPLOAD_LIMITS[kind];
  if (!cfg) return null;
  if (file.size > cfg.maxBytes) {
    const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    return `File is ${sizeMb} MB — the limit for ${kind.replace("_", " ")} is ${cfg.label}. Please choose a smaller file.`;
  }
  return null;
}
